import React from 'react';
import ClientCarousel from '../home/client-carousel';
import ScheduleCallGreen from '../common/schedule-call-green';

const TechHeroAgricultureIndustry = () => {
    return (
        <section className="hero home-hero technology-herosection relative aiml-hero-section">
            <video playsInline autoPlay muted loop className="aimlvideo" height="100%" width="100%">
                <source src="media/video-agriculture-hero.mp4" type="video/mp4" />
            </video>
            <div className="counter-overlay"></div>
            <div className="container lg:container md:mx-auto top-hero">
                <div className="row grid lg:grid-cols-12 hero-row gap-6 relative z-[1] h-full">
                    <div className="lg:col-span-8 md:col-span-11 gap-4 grid">
                        <div className="inline-flex flex-col lg:items-start gap-5 hero-content justify-center h-full">
                            <p className="mb-0 fs-lg font-semibold text-white">Agriculture Software Development Company</p>
                            <h1 className="mb-0 text-[#00B050]">Empowering Farms with Smarter, Scalable AgTech Solutions</h1>
                            <p className="mb-0 font-semibold text-white">
                                At Moweb Technologies, we partner with agribusinesses, cooperatives, and agtech startups to build
                                intelligent, data-driven solutions that transform farming operations. Whether you&apos;re
                                optimizing field productivity, automating livestock tracking, or building a smart irrigation
                                platform—we bring deep expertise in agriculture software development to the table.
                            </p>
                            <ScheduleCallGreen />
                        </div>
                    </div>
                </div>
            </div>
            <ClientCarousel />
        </section>
    );
};

export default TechHeroAgricultureIndustry;
